import script from "./UltimasNoticiasFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./UltimasNoticiasFooter.vue?vue&type=script&setup=true&lang=js"

import "./UltimasNoticiasFooter.vue?vue&type=style&index=0&id=5634f056&lang=css"

const __exports__ = script;

export default __exports__